module.exports = __webpack_public_path__ + "static/media/Icon_menu_repair.a57c66d8.svg";